module.exports = __webpack_public_path__ + "img/giropay.4c96783.svg";